import React, { SVGProps } from "react";

export const JFLogoDivider = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1"
    height="72"
    viewBox="0 0 1 72"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="1" height="72" fill="currentColor" />
  </svg>
);
